import { Tag } from 'antd';

export const STATUS_META = {
  PENDING_DRIVER: ['Chờ tài xế', 'processing'],
  CONFIRMED: ['Đã xác nhận', 'success'],
  REJECTED: ['Tài xế từ chối', 'error'],
  EXPIRED: ['Hết hạn giữ ghế', 'default'],
  CANCELLED: ['Đã hủy', 'warning'],
  PICKUP_FAILED: ['Đón khách thất bại', 'error'],
};

export const STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(STATUS_META).map(([value, meta]) => ({ value, label: meta[0] })),
];

export const formatBookingDate = (value) => (value ? new Date(value).toLocaleString('vi-VN') : '—');
export const formatBookingMoney = (value) => (value == null ? '—' : `${Number(value).toLocaleString('vi-VN')} ₫`);

export const getRideBookingErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu booking';

export function RideBookingStatusTag({ status }) {
  const [label, color] = STATUS_META[status] || [status || '—', 'default'];
  return <Tag color={color}>{label}</Tag>;
}
